const BASE_URL: string =
  (process.env.REACT_APP_BASE_API_URL || "").replace(/\/+$/, "");

export const API_URL = {
  USER: `${BASE_URL}/api/user`,
  DOWNLOAD_FILE: `${BASE_URL}/api/download/file`,
  CORPORATE_NUMBER: `${BASE_URL}/api/corporate-number/validate`,
  VERIFY: `${BASE_URL}/api/verify`,
  UNICON: `${BASE_URL}/api/unicon`,
};
